// React Imports
import * as React from 'react';
import {useEffect, useState} from "react";

import {useDispatch, useSelector} from "react-redux";

// Mui Imports
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';

// App Imports
import {
    DataGrid,
    GridToolbarColumnsButton,
    GridToolbarContainer,
    GridToolbarDensitySelector, GridToolbarExport,
    GridToolbarFilterButton
} from "@mui/x-data-grid";
import CustomFooter from "../../CommonComponents/GridCustomFooter";
import {changeContractDetailList} from "./contractDetailListSlice";
import {getContractCdpvfList} from "../ContractClient";
import {Stack} from "@mui/material";
import Typography from "@mui/material/Typography";


// Main Function
export default function ContractCdpvfListDrawer() {


    // ****************** BEGIN STATES ****************************

    const [contractCdpvfList, setContractCdpvfList] = useState([]);

    // ****************** END STATES ****************************


    // ****************** BEGIN STORE ****************************

    const selectorContractId = useSelector((state) => state.contractDetailListSlc.value.contractId);
    const selectorContractName = useSelector((state) => state.contractDetailListSlc.value.contractName);
    const selectorDataPointId = useSelector((state) => state.contractDetailListSlc.value.dataPointId);
    const selectorCdpvfListDrawerState = useSelector((state) => state.contractDetailListSlc.value.cdpvfListDrawerState);

    // ********************** END STORE ********************************


    // ****************** BEGIN DISPATCH ****************************

    const dispatchData = useDispatch();

    // ****************** END DISPATCH ****************************


    // ****************** BEGIN FETCH ****************************

    const fetchContractCdpvfList = () =>
        getContractCdpvfList(selectorContractId, selectorDataPointId)

            .then(data => {
                console.log("this as my response");
                console.log(data);
                setContractCdpvfList(data);
            });

    // ****************** END FETCH ****************************


    // ******************** BEGIN USE EFFECTS *******************

    useEffect(() => {
        fetchContractCdpvfList();
    }, [ useSelector((state) => state.contractDetailListSlc.value.cdpvfListDrawerState)===true]);

    // ******************** END USE EFFECTS *******************


    // ***************** BEGIN CONTROLS ***************************

    function closeContractCdpvfListDrawer() {
        dispatchData(changeContractDetailList({id: 0, cdpvfListDrawerState: false}));
    };

    // *************** END CONTROLS *******************************


    // ***************** BEGIN MISC ***************************

    const renderContractCdpvfList = contractCdpvfList => {
        if (contractCdpvfList.length <= 0) {
            return "No Data";
        }}

    // *************** END MISC *******************************


    // ****************** BEGIN TOOLBAR ****************************

    function CustomToolbar() {
        return (

            <GridToolbarContainer>
                <Box sx= {{
                    flexGrow: 1}}>
                    <GridToolbarColumnsButton />
                    <GridToolbarFilterButton sx={{mr: 3}} />
                    <GridToolbarDensitySelector />

                </Box>
                <Box sx= {{
                    flexGrow: 1}}>
                </Box>
                <Box sx= {{
                    flexGrow: 1,
                    display: { xs: 'none', md: 'flex' },
                    alignContent: 'flex-end',
                    justifyContent: 'flex-end',
                    ml:30
                }}>
                    <GridToolbarExport  />
                </Box>
            </GridToolbarContainer>
        );
    }

// ********************END TOOLBAR ********************************


    // ****************** BEGIN COLUMNS ****************************

    const columns = contractCdpvfList => [

        {
            field: 'id',
            headerName: 'ID',
            description: '',
            sortable: true,
            editable: false,
            width: 50,
            hide: true,
        },
        {    field: 'sectionOrdinal',
            headerName: 'Section #',
            description: '',
            sortable: true,
            width: 80,
            hide: false,
        },
        {
            field: 'sectionName',
            headerName: 'Name',
            description: '',
            sortable: true,
            editable: false,
            width: 500,
        },
        {    field: 'cdpOrdinal',
            headerName: 'CDP Order',
            description: '',
            sortable: true,
            width: 80,
            hide: false,
        },
        {
            field: 'dataPointId',
            headerName: 'DP ID',
            description: '',
            sortable: true,
            editable: false,
            width: 80,
            hide: false,
        },
        {
            field: 'dataPointName',
            headerName: 'Data Point',
            description: '',
            sortable: true,
            editable: false,
            width: 300,
            hide: false,
        },
        {    field: 'hierarchy',
            headerName: 'Path',
            description: '',
            sortable: true,
            width: 100,
            hide: false,
        },
        {    field: 'filterName',
            headerName: 'Filter Data Point',
            description: '',
            sortable: true,
            width: 200,
            hide: false,
        },
        {
            field: 'singleValue',
            headerName: 'Single Value',
            description: '',
            sortable: true,
            editable: false,
            width: 200,
            hide: false,
        },
        {
            field: 'fromValue',
            headerName: 'From Value',
            description: '',
            sortable: true,
            editable: false,
            width: 100,
            hide: false,
        },
        {
            field: 'toValue',
            headerName: 'To Value',
            description: '',
            sortable: true,
            editable: false,
            width: 100,
            hide: false,
        },
    ];

    // ****************** END COLUMNS ****************************


    // ****************** BEGIN RETURN ****************************

    return (
        <div>
            <Drawer
                PaperProps={{
                    sx: { width: 1800 },
                }}
                anchor='right'
                open={selectorCdpvfListDrawerState}
                initialState={{open: false}}
                onClose={closeContractCdpvfListDrawer}
            >
                <Box style={{cursor:'pointer'}} sx= {{pl: 2}}>
                    <h1 onClick={() => closeContractCdpvfListDrawer()}>Contract Data Point Value Filter List</h1>
                    <Stack direction="row" spacing={1}>
                        {/*<Typography component="span">id:</Typography>*/}
                        {/*<Typography component="span" fontWeight="bold">{selectorContractId}</Typography>*/}
                        {/*<Box sx={{ ml: 6 }} /> /!* Adds extra spacing before 'name:' *!/*/}
                        {/*<Typography component="span">name:</Typography>*/}
                        <Typography component="span" fontWeight="bold">{selectorContractName}</Typography>
                    </Stack>
                </Box>
                <DataGrid
                    experimentalFeatures={{ newEditingApi: true }}
                    initialState={{
                    }}
                    aria-label={"ContractCdpvfList"}
                    rows={contractCdpvfList}
                    disableDensitySelector={true}
                    disableColumnSelector={true}
                    columns={columns(contractCdpvfList)}
                    density={"compact"}
                    pageSize={100}
                    rowsPerPageOptions={[100]}
                    rowKey={contractCdpvfList => contractCdpvfList.id}
                    components={{
                        Toolbar: CustomToolbar,
                        Footer: CustomFooter,
                    }}
                />

            </Drawer>
        </div>
    );

    // ****************** END RETURN ****************************

}
